import { call, put } from 'redux-saga/effects';

import request from './request';
import {
  createAlertSettingFailed,
  createAlertSettingRequested,
  createAlertSettingSucceeded,
  deleteAlertSettingFailed,
  deleteAlertSettingRequested,
  deleteAlertSettingSucceeded,
  updateAlertSettingFailed,
  updateAlertSettingRequested,
  updateAlertSettingSucceeded,
} from '../../../actions';
import api from '../../../api';

export function* createAlertSettingRequest(data) {
  yield put(createAlertSettingRequested(data));

  try {
    const { item } = yield call(request, api.createAlertSetting, data);

    const action = createAlertSettingSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = createAlertSettingFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* updateAlertSettingRequest(id, data) {
  yield put(updateAlertSettingRequested(id, data));

  try {
    const { alertSetting } = yield call(request, api.updateAlertSetting, id, data);

    const action = updateAlertSettingSucceeded(alertSetting);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = updateAlertSettingFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* deleteAlertSettingRequest(id) {
  yield put(deleteAlertSettingRequested(id));

  try {
    const { alertSetting } = yield call(request, api.deleteAlertSetting, id);

    const action = deleteAlertSettingSucceeded(alertSetting);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = deleteAlertSettingFailed(id, error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}
